__turbopack_context__.v({
  "className": "noto_sans_jp_4315791a-module__MJ4X0W__className",
});
